import Request from './request';
import store from '@/store.js';

async function getAccountSettings(data){
    return Request("get","api/settings/get-account-settings", data)
}

async function getShopSettings(data){
    const response = await Request('post', "api/settings/get-shop-settings", data);
    if (response.data && response.data.status.isOK()) {
          store.commit("SHOPSETTING", response.data.settings);
    }
    return response;
}

async function getSettings(data) {
    return Request("get","api/settings/get-settings/", data)
}

export default {
    getAccountSettings,
    getSettings,
    getShopSettings,
}
